module.exports = __webpack_public_path__ + "media/images/assigned-task-icon-hover-c577f986a9ac712358e2c7b16a149bcf.svg";